import React from "react";
import { Link } from "react-router-dom";
import { assets } from "../../assets/assets";
import SEO from "../common/SEO";

const STATS = [
  { value: '15+',    label: 'Years of Excellence' },
  { value: '10,000+', label: 'Students Trained' },
  { value: '250+',   label: 'Hiring Partners' },
  { value: '95%+',   label: 'Placement Rate' },
  { value: '50+',    label: 'Expert Trainers' },
];

const VALUES = [
  {
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#3B82F6" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/>
      </svg>
    ),
    title: 'Holistic Learning',
    desc: 'We go beyond knowledge transfer — we nurture well-rounded professionals equipped for comprehensive growth in the real world.',
  },
  {
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#3B82F6" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8"/><path d="M12 17v4"/>
        <polyline points="9 10 12 13 15 10"/>
      </svg>
    ),
    title: 'Industry-Relevant Training',
    desc: 'Every course is designed with the current and future demands of the IT industry, ensuring graduates are immediately job-ready.',
  },
  {
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#3B82F6" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
      </svg>
    ),
    title: 'Innovation in Education',
    desc: 'We continuously push beyond traditional education, incorporating pioneering methods and technologies to enrich learning.',
  },
  {
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#3B82F6" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/>
        <path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/>
      </svg>
    ),
    title: 'Expert Mentorship',
    desc: "Our trainers are industry professionals with decades of hands-on experience, not just academics — they've been where you want to go.",
  },
  {
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#3B82F6" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2"/>
        <line x1="12" y1="12" x2="12" y2="16"/><line x1="10" y1="14" x2="14" y2="14"/>
      </svg>
    ),
    title: 'Placement Support',
    desc: 'From resume building to mock interviews and direct company referrals, we stay committed until you land your dream role.',
  },
  {
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#3B82F6" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
      </svg>
    ),
    title: 'Real-World Experience',
    desc: 'Students work on live client projects from day one — building portfolios and confidence alongside actual industry workflows.',
  },
];

const AboutPage = () => (
  <>
    <SEO
      title="About Us"
      path="/about"
      description="UPL Snipe — Unlimited Power of Learning — is a tech education company bridging the gap between students and the IT industry since 2010. 10,000+ students trained, 250+ hiring partners, 95%+ placement rate."
      keywords="about UPL Snipe, tech education company, IT training institute India, placement support, career training"
    />
    <style>{`
      #about-hero { background:linear-gradient(135deg,#050D1E 0%,#091525 40%,#0C1B38 70%,#0A1628 100%) !important; padding:72px 5% 64px !important; font-family:'Inter','Segoe UI',sans-serif; }
      #about-hero-inner { max-width:1100px; margin:0 auto; display:grid; grid-template-columns:1fr 1fr; gap:56px; align-items:center; }
      #about-hero-eyebrow { display:inline-block; font-size:11px; font-weight:800; letter-spacing:0.14em; color:rgba(255,255,255,0.6); background:rgba(59,130,246,0.15); border:1px solid rgba(59,130,246,0.3); padding:4px 14px; border-radius:20px; margin-bottom:16px; text-transform:uppercase; }
      #about-hero-title { font-size:clamp(32px,4vw,52px); font-weight:900; color:#fff; line-height:1.15; letter-spacing:-0.03em; margin:0 0 18px; }
      #about-hero-title span { background:linear-gradient(90deg,#3B82F6,#60A5FA); -webkit-background-clip:text; -webkit-text-fill-color:transparent; }
      #about-hero-sub { font-size:15px; color:rgba(255,255,255,0.7); line-height:1.75; margin:0 0 28px; }
      #about-hero-btns { display:flex; gap:12px; flex-wrap:wrap; }
      .about-btn-primary { padding:12px 28px; background:#2563EB; color:#fff; text-decoration:none; border-radius:10px; font-size:14px; font-weight:700; transition:background 0.2s; }
      .about-btn-primary:hover { background:#1D4ED8; color:#fff; }
      .about-btn-outline { padding:12px 28px; border:1.5px solid rgba(255,255,255,0.25); color:#fff; text-decoration:none; border-radius:10px; font-size:14px; font-weight:600; transition:all 0.2s; background:none; cursor:pointer; font-family:inherit; }
      .about-btn-outline:hover { border-color:#3B82F6; color:#60A5FA; }
      #about-hero-visual { display:flex; align-items:center; justify-content:center; }
      #about-stats { background:#0B1629 !important; padding:36px 5% !important; border-top:1px solid rgba(59,130,246,0.15); }
      #about-stats-inner { max-width:1100px; margin:0 auto; display:grid; grid-template-columns:repeat(5,1fr); gap:0; }
      .astat { text-align:center; padding:12px 8px; border-right:1px solid rgba(59,130,246,0.12); }
      .astat:last-child { border-right:none; }
      .astat-val { font-size:clamp(22px,3vw,32px); font-weight:900; color:#3B82F6; letter-spacing:-0.02em; line-height:1; margin-bottom:5px; font-family:'Inter','Segoe UI',sans-serif; }
      .astat-lbl { font-size:12px; color:rgba(255,255,255,0.55); font-weight:500; font-family:'Inter','Segoe UI',sans-serif; }
      #about-story { background:#fff; padding:72px 5%; font-family:'Inter','Segoe UI',sans-serif; }
      #about-story-inner { max-width:1100px; margin:0 auto; display:grid; grid-template-columns:1fr 1fr; gap:64px; align-items:center; }
      .about-eyebrow { display:inline-block; font-size:11px; font-weight:800; letter-spacing:0.14em; color:#2563EB; background:#EFF6FF; border:1px solid #BFDBFE; padding:4px 14px; border-radius:20px; margin-bottom:14px; text-transform:uppercase; }
      .about-section-title { font-size:clamp(24px,3vw,36px); font-weight:900; color:#0F172A; line-height:1.2; letter-spacing:-0.02em; margin:0 0 16px; }
      .about-section-title span { color:#2563EB; }
      .about-body-text { font-size:15px; color:#475569; line-height:1.8; margin:0 0 14px; }
      #about-story-visual { background:linear-gradient(135deg,#EFF6FF,#DBEAFE); border-radius:20px; padding:32px; display:flex; flex-direction:column; gap:16px; }
      .about-timeline-item { display:flex; gap:16px; align-items:flex-start; }
      .about-tl-dot { width:36px; height:36px; border-radius:50%; background:#2563EB; display:flex; align-items:center; justify-content:center; flex-shrink:0; margin-top:2px; }
      .about-tl-year { font-size:13px; font-weight:800; color:#0F172A; margin:0 0 3px; }
      .about-tl-desc { font-size:13px; color:#475569; margin:0; line-height:1.5; }
      #about-mv { background:#F8FAFC; padding:72px 5%; font-family:'Inter','Segoe UI',sans-serif; border-top:1px solid #E2E8F0; }
      #about-mv-inner { max-width:1100px; margin:0 auto; }
      #about-mv-grid { display:grid; grid-template-columns:1fr 1fr; gap:28px; margin-top:40px; }
      .about-mv-card { border-radius:16px; overflow:hidden; box-shadow:0 4px 24px rgba(0,0,0,0.07); }
      .about-mv-card-head { padding:24px 28px 20px; }
      .about-mv-card-head h3 { font-size:18px; font-weight:800; color:#fff; margin:0; }
      .about-mv-card-body { background:#fff; padding:24px 28px; }
      .about-mv-card-body p { font-size:14.5px; color:#475569; line-height:1.8; margin:0; }
      #about-values { background:#fff; padding:72px 5%; font-family:'Inter','Segoe UI',sans-serif; border-top:1px solid #E2E8F0; }
      #about-values-inner { max-width:1100px; margin:0 auto; }
      #about-values-grid { display:grid; grid-template-columns:repeat(3,1fr); gap:24px; margin-top:40px; }
      .about-val-card { border:1.5px solid #E2E8F0; border-radius:14px; padding:24px; transition:box-shadow 0.2s,border-color 0.2s; background:#fff; }
      .about-val-card:hover { box-shadow:0 8px 32px rgba(37,99,235,0.1); border-color:#BFDBFE; }
      .about-val-icon { width:52px; height:52px; border-radius:12px; background:#EFF6FF; display:flex; align-items:center; justify-content:center; margin-bottom:14px; }
      .about-val-title { font-size:16px; font-weight:800; color:#0F172A; margin:0 0 8px; }
      .about-val-desc { font-size:13.5px; color:#64748B; line-height:1.65; margin:0; }
      #about-founder { background:#0A1628 !important; padding:72px 5% !important; font-family:'Inter','Segoe UI',sans-serif; }
      #about-founder-inner { max-width:1100px; margin:0 auto; display:grid; grid-template-columns:320px 1fr; gap:56px; align-items:center; }
      #about-founder-card { background:linear-gradient(160deg,#0D1E3D,#162650); border:1.5px solid rgba(59,130,246,0.2); border-radius:20px; padding:32px; text-align:center; }
      #about-founder-avatar { width:100px; height:100px; border-radius:50%; background:linear-gradient(135deg,#1E3A5F,#2563EB); border:3px solid rgba(59,130,246,0.4); display:flex; align-items:center; justify-content:center; margin:0 auto 16px; font-size:36px; font-weight:900; color:#fff; }
      #about-founder-name { font-size:18px; font-weight:800; color:#fff; margin:0 0 4px; }
      #about-founder-role { font-size:12px; color:#60A5FA; font-weight:600; margin:0 0 16px; letter-spacing:0.05em; text-transform:uppercase; }
      #about-founder-exp { font-size:13px; color:rgba(255,255,255,0.6); line-height:1.6; margin:0 0 18px; }
      #about-founder-linkedin { display:inline-flex; align-items:center; gap:8px; padding:9px 18px; background:rgba(59,130,246,0.15); border:1px solid rgba(59,130,246,0.3); border-radius:8px; color:#60A5FA; text-decoration:none; font-size:12.5px; font-weight:600; transition:background 0.2s; }
      #about-founder-linkedin:hover { background:rgba(59,130,246,0.28); }
      #about-founder-text { }
      #about-founder-text h2 { font-size:clamp(22px,2.5vw,32px); font-weight:900; color:#fff; margin:0 0 16px; line-height:1.25; letter-spacing:-0.02em; }
      #about-founder-text p { font-size:15px; color:rgba(255,255,255,0.7); line-height:1.8; margin:0 0 14px; }
      #about-founder-text p:last-child { margin:0; }
      #about-cta { background:linear-gradient(135deg,#0C1B38 0%,#0D1E3D 100%) !important; padding:64px 5% !important; font-family:'Inter','Segoe UI',sans-serif; border-top:1px solid rgba(59,130,246,0.15); }
      #about-cta-inner { max-width:860px; margin:0 auto; text-align:center; }
      #about-cta h2 { font-size:clamp(24px,3vw,38px); font-weight:900; color:#fff; margin:0 0 14px; letter-spacing:-0.02em; }
      #about-cta p { font-size:15px; color:rgba(255,255,255,0.65); margin:0 0 32px; line-height:1.7; }
      #about-cta-btns { display:flex; gap:14px; justify-content:center; flex-wrap:wrap; }
      #about-contact-row { display:flex; justify-content:center; gap:32px; flex-wrap:wrap; margin-top:32px; padding-top:28px; border-top:1px solid rgba(255,255,255,0.1); }
      .about-contact-item { display:flex; align-items:center; gap:10px; color:rgba(255,255,255,0.65); font-size:14px; text-decoration:none; font-family:'Inter','Segoe UI',sans-serif; }
      .about-contact-item:hover { color:#60A5FA; }
      @media(max-width:900px) {
        #about-hero-inner,#about-story-inner,#about-mv-grid,#about-founder-inner { grid-template-columns:1fr; }
        #about-hero-visual { display:none; }
        #about-stats-inner { grid-template-columns:repeat(3,1fr); }
        #about-values-grid { grid-template-columns:repeat(2,1fr); }
        #about-founder-inner { grid-template-columns:1fr; }
      }
      @media(max-width:560px) {
        #about-stats-inner { grid-template-columns:repeat(2,1fr); }
        #about-values-grid { grid-template-columns:1fr; }
      }
    `}</style>

    {/* ── HERO ── */}
    <section id="about-hero">
      <div id="about-hero-inner">
        <div>
          <div id="about-hero-eyebrow">About UPL Snipe</div>
          <h1 id="about-hero-title">
            Empowering the Next<br />
            Generation of <span>Tech Leaders</span>
          </h1>
          <p id="about-hero-sub">
            UPL — Unlimited Power of Learning — is a tech education company on a mission to bridge
            the gap between students and the IT industry. Since 2010, we've trained thousands of
            learners, connecting them with real projects, real mentors, and real careers.
          </p>
          <div id="about-hero-btns">
            <Link to="/programs" className="about-btn-primary">Explore Programs</Link>
            <button className="about-btn-outline" onClick={() => window.dispatchEvent(new CustomEvent('openApplyModal'))}>Get in Touch</button>
          </div>
        </div>

        <div id="about-hero-visual">
          <svg width="360" height="300" viewBox="0 0 360 300" fill="none" xmlns="http://www.w3.org/2000/svg">
            {/* Background circles */}
            <circle cx="180" cy="150" r="130" fill="rgba(37,99,235,0.06)" stroke="rgba(59,130,246,0.12)" strokeWidth="1"/>
            <circle cx="180" cy="150" r="90" fill="rgba(37,99,235,0.06)" stroke="rgba(59,130,246,0.1)" strokeWidth="1"/>
            {/* Center UPL badge */}
            <circle cx="180" cy="150" r="52" fill="#1E3A5F" stroke="#3B82F6" strokeWidth="1.5"/>
            <text x="180" y="143" textAnchor="middle" fill="#fff" fontSize="18" fontWeight="900" fontFamily="Inter">UPL</text>
            <text x="180" y="162" textAnchor="middle" fill="#60A5FA" fontSize="8.5" fontWeight="600" fontFamily="Inter">SNIPE</text>
            {/* Orbit nodes */}
            <circle cx="180" cy="30" r="28" fill="#0D1E3D" stroke="#3B82F6" strokeWidth="1.5"/>
            <text x="180" y="27" textAnchor="middle" fill="#60A5FA" fontSize="8" fontWeight="700" fontFamily="Inter">10,000+</text>
            <text x="180" y="38" textAnchor="middle" fill="rgba(255,255,255,0.6)" fontSize="7" fontFamily="Inter">Students</text>
            <circle cx="310" cy="100" r="28" fill="#0D1E3D" stroke="#3B82F6" strokeWidth="1.5"/>
            <text x="310" y="97" textAnchor="middle" fill="#60A5FA" fontSize="8" fontWeight="700" fontFamily="Inter">250+</text>
            <text x="310" y="108" textAnchor="middle" fill="rgba(255,255,255,0.6)" fontSize="7" fontFamily="Inter">Partners</text>
            <circle cx="310" cy="200" r="28" fill="#0D1E3D" stroke="#3B82F6" strokeWidth="1.5"/>
            <text x="310" y="197" textAnchor="middle" fill="#60A5FA" fontSize="8" fontWeight="700" fontFamily="Inter">95%+</text>
            <text x="310" y="208" textAnchor="middle" fill="rgba(255,255,255,0.6)" fontSize="7" fontFamily="Inter">Placed</text>
            <circle cx="180" cy="270" r="28" fill="#0D1E3D" stroke="#3B82F6" strokeWidth="1.5"/>
            <text x="180" y="267" textAnchor="middle" fill="#60A5FA" fontSize="8" fontWeight="700" fontFamily="Inter">15+</text>
            <text x="180" y="278" textAnchor="middle" fill="rgba(255,255,255,0.6)" fontSize="7" fontFamily="Inter">Years</text>
            <circle cx="50" cy="200" r="28" fill="#0D1E3D" stroke="#3B82F6" strokeWidth="1.5"/>
            <text x="50" y="197" textAnchor="middle" fill="#60A5FA" fontSize="8" fontWeight="700" fontFamily="Inter">50+</text>
            <text x="50" y="208" textAnchor="middle" fill="rgba(255,255,255,0.6)" fontSize="7" fontFamily="Inter">Trainers</text>
            <circle cx="50" cy="100" r="28" fill="#0D1E3D" stroke="#3B82F6" strokeWidth="1.5"/>
            <text x="50" y="97" textAnchor="middle" fill="#60A5FA" fontSize="8" fontWeight="700" fontFamily="Inter">500+</text>
            <text x="50" y="108" textAnchor="middle" fill="rgba(255,255,255,0.6)" fontSize="7" fontFamily="Inter">Projects</text>
            {/* Connector lines */}
            {[[180,58],[282,114],[282,186],[180,242],[78,186],[78,114]].map(([x,y],i) => (
              <line key={i} x1="180" y1="150" x2={x} y2={y} stroke="rgba(59,130,246,0.2)" strokeWidth="1" strokeDasharray="4 4"/>
            ))}
          </svg>
        </div>
      </div>
    </section>

    {/* ── STATS ── */}
    <section id="about-stats">
      <div id="about-stats-inner">
        {STATS.map(s => (
          <div className="astat" key={s.label}>
            <div className="astat-val">{s.value}</div>
            <div className="astat-lbl">{s.label}</div>
          </div>
        ))}
      </div>
    </section>

    {/* ── OUR STORY ── */}
    <section id="about-story">
      <div id="about-story-inner">
        <div>
          <div className="about-eyebrow">Our Story</div>
          <h2 className="about-section-title">From a Vision to a <span>Movement</span></h2>
          <p className="about-body-text">
            Founded in 2010, UPL was born out of a simple but powerful observation — thousands of
            talented graduates were entering the workforce unprepared for what the IT industry
            actually demanded. Traditional education was lagging behind real-world needs.
          </p>
          <p className="about-body-text">
            We set out to change that. UPL became a bridge — connecting ambitious learners to
            industry-grade training, live project experience, and direct placement pathways. Today,
            we operate as a full-stack career accelerator, working with leading companies to ensure
            every student we train gets placed.
          </p>
          <p className="about-body-text">
            Our programs evolve constantly, driven by feedback from hiring partners and alumni who
            are now leading teams at TCS, Infosys, Wipro, Capgemini, and beyond.
          </p>
        </div>

        <div id="about-story-visual">
          <div style={{ fontWeight: 800, fontSize: 14, color: '#1E3A5F', marginBottom: 8 }}>OUR JOURNEY</div>
          {[
            { year: '2010', desc: 'Founded with a mission to bridge the IT skills gap for fresh graduates.' },
            { year: '2014', desc: 'Expanded to 500+ students and launched industry partnership programs.' },
            { year: '2018', desc: 'Introduced live project training and ESPRP placement program.' },
            { year: '2021', desc: 'Crossed 5,000 students placed. Launched online learning platform.' },
            { year: '2024', desc: '10,000+ alumni, 250+ hiring partners, 95%+ placement rate.' },
          ].map((t, i) => (
            <div className="about-timeline-item" key={i}>
              <div className="about-tl-dot">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
              </div>
              <div>
                <div className="about-tl-year">{t.year}</div>
                <p className="about-tl-desc">{t.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* ── MISSION & VISION ── */}
    <section id="about-mv">
      <div id="about-mv-inner">
        <div style={{ textAlign: 'center' }}>
          <div className="about-eyebrow" style={{ margin: '0 auto 14px' }}>What Drives Us</div>
          <h2 className="about-section-title">Our Mission &amp; <span>Vision</span></h2>
        </div>
        <div id="about-mv-grid">
          <div className="about-mv-card">
            <div className="about-mv-card-head" style={{ background: 'linear-gradient(135deg,#1E3A5F,#2563EB)' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <div style={{ width: 40, height: 40, borderRadius: 10, background: 'rgba(255,255,255,0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                </div>
                <h3 style={{ fontSize: 18, fontWeight: 800, color: '#fff', margin: 0 }}>Our Mission</h3>
              </div>
            </div>
            <div className="about-mv-card-body">
              <p>
                To bridge the gap between students and the dynamic expectations of the IT industry —
                empowering every learner with the skills, mindset, and real-world experience needed
                to build a thriving career in technology. We are committed to making quality,
                industry-aligned education accessible to all.
              </p>
            </div>
          </div>

          <div className="about-mv-card">
            <div className="about-mv-card-head" style={{ background: 'linear-gradient(135deg,#4F46E5,#7C3AED)' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <div style={{ width: 40, height: 40, borderRadius: 10, background: 'rgba(255,255,255,0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
                </div>
                <h3 style={{ fontSize: 18, fontWeight: 800, color: '#fff', margin: 0 }}>Our Vision</h3>
              </div>
            </div>
            <div className="about-mv-card-body">
              <p>
                To be the most trusted career accelerator in India — creating exceptional learning
                experiences in technology that empower individuals with cutting-edge IT skills,
                career guidance, and the confidence needed to navigate and thrive in the
                ever-evolving tech landscape.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* ── CORE VALUES ── */}
    <section id="about-values">
      <div id="about-values-inner">
        <div style={{ textAlign: 'center' }}>
          <div className="about-eyebrow" style={{ margin: '0 auto 14px' }}>Why UPL</div>
          <h2 className="about-section-title">The Pillars Behind <span>Our Success</span></h2>
          <p style={{ fontSize: 15, color: '#64748B', maxWidth: 560, margin: '0 auto' }}>
            Six principles that shape how we train, support, and launch every student's career.
          </p>
        </div>
        <div id="about-values-grid">
          {VALUES.map(v => (
            <div className="about-val-card" key={v.title}>
              <div className="about-val-icon">{v.icon}</div>
              <div className="about-val-title">{v.title}</div>
              <p className="about-val-desc">{v.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* ── FOUNDER ── */}
    <section id="about-founder">
      <div id="about-founder-inner">
        <div id="about-founder-card">
          <div id="about-founder-avatar">G</div>
          <div id="about-founder-name">G.D. Mallikarjuna</div>
          <div id="about-founder-role">Founder &amp; CEO</div>
          <p id="about-founder-exp">
            20+ years of expertise as a technologist, trainer, and developer across academia and industry.
          </p>
          <a
            href="https://www.linkedin.com/in/mallikarjuna-g-d-b4660146"
            target="_blank"
            rel="noopener noreferrer"
            id="about-founder-linkedin"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"/><circle cx="4" cy="4" r="2"/></svg>
            Connect on LinkedIn
          </a>
        </div>

        <div id="about-founder-text">
          <div className="about-eyebrow" style={{ background: 'rgba(59,130,246,0.15)', color: '#60A5FA', border: '1px solid rgba(59,130,246,0.3)' }}>Leadership</div>
          <h2>Built by a Practitioner,<br />Led with Purpose</h2>
          <p>
            UPL was founded and is led by a team of seasoned professionals with over two decades
            of combined academic and industry experience. G.D. Mallikarjuna, our visionary founder,
            began his journey with a strong academic foundation that evolved into a multifaceted
            career spanning software development, corporate training, and education leadership.
          </p>
          <p>
            His belief is simple: the best way to prepare students for the industry is to expose
            them to it early. That's why UPL's programs are built around live projects, real client
            work, and mentorship from professionals who've done it themselves — not just taught it.
          </p>
          <p>
            Under his leadership, UPL has grown from a local training center to one of the
            region's most respected career accelerators, with thousands of alumni working across
            leading IT companies worldwide.
          </p>
        </div>
      </div>
    </section>

    {/* ── CTA ── */}
    <section id="about-cta">
      <div id="about-cta-inner">
        <div className="about-eyebrow" style={{ background: 'rgba(59,130,246,0.15)', color: '#60A5FA', border: '1px solid rgba(59,130,246,0.3)', margin: '0 auto 16px' }}>Join UPL</div>
        <h2>Ready to Launch Your Tech Career?</h2>
        <p>
          Join thousands of students who have transformed their careers with UPL's industry-led
          programs. Your journey to becoming a tech professional starts here.
        </p>
        <div id="about-cta-btns">
          <Link to="/programs" className="about-btn-primary">Explore Programs</Link>
          <button className="about-btn-outline" onClick={() => window.dispatchEvent(new CustomEvent('openApplyModal'))}>Talk to an Advisor</button>
        </div>
        <div id="about-contact-row">
          <a href="tel:+918431663025" className="about-contact-item">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81a19.79 19.79 0 01-3.07-8.67A2 2 0 012 1h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.91 8.91a16 16 0 006.09 6.09l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/></svg>
            +91 84316 63025
          </a>
          <a href="mailto:hr@uplsnipe.com" className="about-contact-item">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
            hr@uplsnipe.com
          </a>
        </div>
      </div>
    </section>
  </>
);

export default AboutPage;
